export default __webpack_public_path__ + "static/topo-menu-mob-044d77291b596296a30af3fe695f6eba.png";